(() => {
  const script = document.currentScript;
  const loginPath = script?.dataset.loginUrl || '/account/login';
  const linkSelector = '[data-cf-tearsheet-download], [data-cf-composition-tearsheet]';
  const guestStorageKey = 'cf-tearsheet-guest-id-v1';
  let dialog;
  let lastFocused;

  function closeDialog() {
    if (!dialog) return;
    dialog.remove();
    dialog = null;
    document.body.classList.remove('cf-tearsheet-limit-open');
    lastFocused?.focus();
  }

  function showLimitDialog() {
    if (dialog) return;
    lastFocused = document.activeElement;
    dialog = document.createElement('div');
    dialog.className = 'cf-tearsheet-limit-overlay';
    dialog.innerHTML = `
      <div class="cf-tearsheet-limit-dialog" role="dialog" aria-modal="true" aria-labelledby="cf-tearsheet-limit-title" aria-describedby="cf-tearsheet-limit-description">
        <button type="button" class="cf-tearsheet-limit-close" aria-label="Close" data-cf-limit-close>&times;</button>
        <h2 id="cf-tearsheet-limit-title">Guest download limit reached</h2>
        <p id="cf-tearsheet-limit-description">You’ve reached the guest tearsheet download limit. Sign in to continue downloading tearsheets without a limit.</p>
        <a class="cf-tearsheet-limit-sign-in" data-cf-limit-login>Sign in to continue</a>
      </div>`;

    const loginUrl = new URL(loginPath, window.location.origin);
    loginUrl.searchParams.set('return_url', window.location.pathname + window.location.search);
    dialog.querySelector('[data-cf-limit-login]').href = loginUrl.pathname + loginUrl.search;
    dialog.querySelector('[data-cf-limit-close]').addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    document.body.appendChild(dialog);
    document.body.classList.add('cf-tearsheet-limit-open');
    dialog.querySelector('[data-cf-limit-login]').focus();
  }

  document.addEventListener('keydown', (event) => {
    if (!dialog) return;
    if (event.key === 'Escape') closeDialog();
    if (event.key !== 'Tab') return;
    const close = dialog.querySelector('[data-cf-limit-close]');
    const login = dialog.querySelector('[data-cf-limit-login]');
    if (event.shiftKey && document.activeElement === close) {
      event.preventDefault();
      login.focus();
    } else if (!event.shiftKey && document.activeElement === login) {
      event.preventDefault();
      close.focus();
    }
  });

  function addGuestId(url) {
    try {
      let guestId = localStorage.getItem(guestStorageKey);
      if (!guestId) {
        guestId = window.crypto?.randomUUID
          ? `cf-guest-${window.crypto.randomUUID()}`
          : `cf-guest-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
        localStorage.setItem(guestStorageKey, guestId);
      }
      url.searchParams.set('guest_id', guestId);
    } catch (_) {
      // The server can still enforce its IP-based limit when storage is unavailable.
    }
  }

  document.addEventListener('click', async (event) => {
    const link = event.target.closest?.(linkSelector);
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();

    const downloadUrl = new URL(link.href, window.location.origin);
    addGuestId(downloadUrl);
    // Open during the click gesture so browsers allow the PDF to use a new tab.
    const pdfTab = window.open('', '_blank');
    if (pdfTab) {
      pdfTab.opener = null;
      pdfTab.document.title = 'Preparing tearsheet';
      pdfTab.document.body.textContent = 'Preparing tearsheet…';
    }

    try {
      const response = await fetch(downloadUrl, { credentials: 'same-origin', cache: 'no-store' });
      if (response.status === 429) {
        pdfTab?.close();
        showLimitDialog();
        return;
      }
      if (!response.ok || !response.headers.get('content-type')?.includes('application/pdf')) {
        const message = (await response.text()).slice(0, 500) || 'Unable to load this tearsheet.';
        if (pdfTab && !pdfTab.closed) pdfTab.document.body.textContent = message;
        else window.alert(message);
        return;
      }
      const pdfUrl = URL.createObjectURL(await response.blob());
      if (pdfTab && !pdfTab.closed) pdfTab.location.replace(pdfUrl);
      else window.location.assign(pdfUrl);
      window.setTimeout(() => URL.revokeObjectURL(pdfUrl), 10 * 60 * 1000);
    } catch (_) {
      // A network failure can use the endpoint's normal browser behavior.
      if (pdfTab && !pdfTab.closed) pdfTab.location.replace(downloadUrl.href);
      else window.location.assign(downloadUrl.href);
    }
  }, true);
})();
